export interface FieldAgentsModel {
    id: number;
    servicePartnerId: number;
    firstName: string;
    lastName: string;
    EmailId: string;
    addressLine1: string;
    addressLine2: string;
    cityId: number;
    areaId: number;
    mobileNumber: string;
    mobileNumber2: string;
    adharNumber: string;
    panNumber: string;
    dateOfJoining: string;
    isActive: boolean;
    available: boolean;
  }
  
  export const FieldAgentsModelData: FieldAgentsModel = {
    id: 0,
    servicePartnerId: 1,
    firstName: '',
    lastName: '',
    EmailId: '',
    addressLine1: '',
    addressLine2: '',
    cityId: 0,
    areaId: 0,
    mobileNumber: '',
    mobileNumber2: '',
    adharNumber: '',
    panNumber: '',
    dateOfJoining: '',
    isActive: true,
    available: null
  };